var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1670_22077)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26C25.7348 26 25.4804 26.1054 25.2929 26.2929C25.1054 26.4804 25 26.7348 25 27V30C25 30.2652 25.1054 30.5196 25.2929 30.7071C25.4804 30.8946 25.7348 31 26 31C26.2652 31 26.5196 30.8946 26.7071 30.7071C26.8946 30.5196 27 30.2652 27 30V27C27 26.7348 26.8946 26.4804 26.7071 26.2929C26.5196 26.1054 26.2652 26 26 26ZM31 22V20C31 18.6739 30.4732 17.4021 29.5355 16.4645C28.5979 15.5268 27.3261 15 26 15C24.6739 15 23.4021 15.5268 22.4645 16.4645C21.5268 17.4021 21 18.6739 21 20V22C20.2044 22 19.4413 22.3161 18.8787 22.8787C18.3161 23.4413 18 24.2044 18 25V32C18 32.7956 18.3161 33.5587 18.8787 34.1213C19.4413 34.6839 20.2044 35 21 35H31C31.7956 35 32.5587 34.6839 33.1213 34.1213C33.6839 33.5587 34 32.7956 34 32V25C34 24.2044 33.6839 23.4413 33.1213 22.8787C32.5587 22.3161 31.7956 22 31 22ZM23 20C23 19.2044 23.3161 18.4413 23.8787 17.8787C24.4413 17.3161 25.2044 17 26 17C26.7956 17 27.5587 17.3161 28.1213 17.8787C28.6839 18.4413 29 19.2044 29 20V22H23V20ZM32 32C32 32.2652 31.8946 32.5196 31.7071 32.7071C31.5196 32.8946 31.2652 33 31 33H21C20.7348 33 20.4804 32.8946 20.2929 32.7071C20.1054 32.5196 20 32.2652 20 32V25C20 24.7348 20.1054 24.4804 20.2929 24.2929C20.4804 24.1054 20.7348 24 21 24H31C31.2652 24 31.5196 24.1054 31.7071 24.2929C31.8946 24.4804 32 24.7348 32 25V32Z",
    fill: "#2948A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1670_22077",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1670_22077"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1670_22077",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSquare);
export default __webpack_public_path__ + "static/media/lockSquare.a2708c757c5a1237deb25dc8265c23d9.svg";
export { ForwardRef as ReactComponent };